module.exports = __webpack_public_path__ + "static/media/MATH134.a8f138f6.PNG";